import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { ComponentProps, Fragment } from 'react';

import { ShareModalPanel } from '~modules/media-library/view/ShareModal/ShareModalPanel';

type Props = Resolve<
  Pick<
    ComponentProps<typeof ShareModalPanel>,
    'assetId' | 'downloadFormats' | 'downloadVariations' | 'hasRestrictions' | 'shareAction'
  > & {
    isOpen: boolean;
    onClose: () => void;
  }
>;

export function ShareModal({ isOpen, onClose, ...PanelProps }: Props) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} as="div" className="relative z-40">
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-50"
          leave="ease-in duration-200"
          leaveFrom="opacity-50"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black opacity-50" />
        </TransitionChild>
        <div className="fixed inset-0 p-8 flex justify-center items-center overflow-hidden">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <DialogPanel as={ShareModalPanel} {...PanelProps} onClose={onClose} className="transition-all transform" />
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
